// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/stylesheets/partials/list-projects.scss
// module id = 449
// module chunks = 0